module.exports = __webpack_public_path__ + "img/marketing.4e9f2232.png";